import React from 'react';
import { 
  List, 
  ListItem, 
  ListItemButton, 
  ListItemText, 
  Typography, 
  Chip, 
  Box,
  Divider
} from '@mui/material';
import { LocalShipping, CheckCircle, Warning, Schedule } from '@mui/icons-material';

const ShipmentList = ({ shipments, selectedShipmentId, onShipmentSelect }) => {
  // Helper function to get status icon
  const getStatusIcon = (status) => {
    switch (status?.toUpperCase()) {
      case 'DELIVERED':
        return <CheckCircle color="success" />;
      case 'IN_TRANSIT':
      case 'SHIPPED':
        return <LocalShipping color="primary" />;
      case 'DELAYED':
        return <Warning color="warning" />;
      default:
        return <Schedule color="action" />;
    }
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Active Shipments
      </Typography>
      <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
        {shipments.length === 0 ? (
          <Typography variant="body2" sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
            No shipments found
          </Typography>
        ) : (
          shipments.map((shipment, index) => (
            <React.Fragment key={shipment.uniqueKey || `${shipment.shipment_id}_${index}`}>
              {index > 0 && <Divider component="li" />}
              <ListItem disablePadding>
                <ListItemButton 
                  selected={selectedShipmentId === shipment.shipment_id}
                  onClick={() => onShipmentSelect(shipment.shipment_id)}
                  sx={{ 
                    borderLeft: selectedShipmentId === shipment.shipment_id 
                      ? '4px solid #1976d2' 
                      : '4px solid transparent',
                    '&:hover': {
                      backgroundColor: 'rgba(25, 118, 210, 0.08)'
                    }
                  }}
                >
                  <ListItemText
                    primary={
                      <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="subtitle1" component="span">
                          {shipment.shipment_id}
                        </Typography>
                        <Chip 
                          icon={getStatusIcon(shipment.status)} 
                          label={shipment.status || 'Unknown'} 
                          size="small"
                          color={
                            shipment.status?.toUpperCase() === 'DELIVERED' ? 'success' :
                            shipment.status?.toUpperCase() === 'IN_TRANSIT' || shipment.status?.toUpperCase() === 'SHIPPED' ? 'primary' :
                            shipment.status?.toUpperCase() === 'DELAYED' ? 'warning' : 'default'
                          }
                          variant="outlined"
                        />
                      </Box>
                    }
                    secondary={
                      <>
                        <Typography variant="body2" component="span" color="text.primary">
                          {shipment.destination?.name || 'Unknown Destination'}
                        </Typography>
                        <Typography variant="body2" component="span" sx={{ display: 'block' }} color="text.secondary">
                          ETA: {formatDate(shipment.estimated_arrival)}
                        </Typography>
                      </>
                    }
                  />
                </ListItemButton>
              </ListItem>
            </React.Fragment>
          ))
        )}
      </List>
    </>
  );
};

export default ShipmentList; 